/**
 * @author Francesco Costa
 * @version 0.1
 */

import Request from './../util/request';
import L from 'leaflet';
import GeoJSONSelector from 'leaflet-geojson-selector';
import leafletscss from 'leaflet/dist/leaflet.css';

export default class GroupMap {

    DEFAULT_OPTIONS = {
        zoomControl: true,
        collapsed: 'responsive'
    };

    REQUIRED_OPTIONS = [
        'el',
        'regionUrl',
        'regionGroupMap'
    ];

    static init() {
        let el = document.getElementById('groupmap');
        if (el && window.groupmapsettings) {
            window.AsdGroupMap = new GroupMap({
                el: el,
                regionUrl: window.groupmapsettings.regionUrl,
                regionGroupMap: window.groupmapsettings.regionGroupMap,
            });
        }
    }

    constructor(options) {
        this.geoList = null;
        this.currentSlide = null;

        for (let key in this.DEFAULT_OPTIONS) {
            if (!options.hasOwnProperty(key)) {
                options[key] = this.DEFAULT_OPTIONS[key];
            }
        }

        for (let i=0; i<this.REQUIRED_OPTIONS.length; i++) {
            if (!options.hasOwnProperty(this.REQUIRED_OPTIONS[i])) {
                console.log('Property '+this.REQUIRED_OPTIONS[i]+' is required');
                return;
            }
        }

        this.el = options.el;
        this.regionUrl = options.regionUrl;
        try {
            this.regionGroupMap = JSON.parse( options.regionGroupMap );
        }
        catch ( e ) {
            console.log(e);
            console.log(options.regionGroupMap);
        }

        this.map_container = this.el.querySelector('.map');
        this.det_container = this.el.querySelector('.details');

        this.isMobile    = window.innerWidth < 768;

        this.options = options;

        this.start();
    }

    start() {
        this.initMap();

        let req = new Request( this.jsonRegionCallback, this );
        req.get( this.regionUrl, [] );
    }

    initMap() {
        this.map         = new L.Map( this.map_container, {
            layers: L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'),
            zoomControl: false,
            attributionControl:true,
            scrollWheelZoom: false,
            dragging: false
        });

        //add zoom control with your options
        L.control.zoom({
            position:'topright'
        }).addTo(this.map);
    }

    /**
     * When JSON of region arrives.
     * In this context $this is the XHR class and the actual class instance
     * can be reached thouugh variable this.caller
     */
    jsonRegionCallback() {
        var response;

        try {
            response = JSON.parse( this.responseText );
        } catch ( e ) {
            console.log( 'Non Json Request' );
            console.log( this.responseText );
            return;
        }

        this.caller.jsonRegion( response );


    }

    jsonRegion( response ) {
        let geoLayer = L.geoJson( response );

        this.geoList = new L.Control.GeoJSONSelector( geoLayer , {
            collapsed: true,
            zoomToLayer: false,
            listDisabled: true,
            activeListFromLayer: true,
            activeLayerFromList: true,
            listOnlyVisibleLayers: false
        }).addTo( this.map );

        this.geoList.on('selector:change', this.selectionChangeCallback.bind(this) );

        // reset map panning without collapsed panel
        if (this.isMobile) {
            let geoList = this.geoList;
            let map = this.map;
            setTimeout( function() {
                let bound = geoList._layer.getBounds();
                map.fitBounds(bound);
            }, 100);
        }
    }

    selectionChangeCallback ( e ) {
        let jsonObj = e.layers[0].feature.properties;
        let targetContainer = document.getElementById('asd-groupmap_region_'+jsonObj.id);

        let closer = targetContainer.querySelector('.closer');
        if (!closer) { console.log('no closer element. to safe website, popup is not showed'); return;}

        this.det_container.classList.remove('closed');
        this.det_container.classList.add('slided');
        this.det_container.style.animationPlayState = 'running';
        targetContainer.classList.add('opened');
        closer.addEventListener('click', this.closeInfo.bind(this) );

        this.currentSlide = targetContainer;
    }

    closeInfo() {
        if (!this.currentSlide) return;
        this.currentSlide.classList.remove('opened');
        this.det_container.classList.add('closed');
        this.det_container.classList.remove('slided');
        this.currentSlide = null;
    }

}
